module.exports = __webpack_public_path__ + "static/img/carac3.7434ca2d.jpg";